// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".quote-card {\n    background: var(--cardBackgroundColor);\n    border: 1px solid var(--inputBorderColor);\n    border-radius: 17px;\n    min-height: 52px;\n    padding: 8px;\n}\n\n@keyframes slide-left {\n    0% { transform: translateX(0); }\n    100% { transform: translateX(-100%); }\n}\n@keyframes slide-left2 {\n    0% { transform: translateX(0); }\n    100% { transform: translateX(-100%); }\n}", ""]);
// Exports
module.exports = exports;
